
export default function SectionCorporat({ _data }) {
  return (
    <div className="section-full p-t120 p-b90 site-bg-gray tw-what-wedo-area">
      <div className="container">
        <div className="row my-5">
          <div className="col-lg-7 col-12 mb-lg-0">
            {/* <!-- TITLE START--> */}
            <div className="section-head center wt-small-separator-outer">
              <div className="wt-small-separator site-text-primary">
                <div>{_data.OurMission.title}</div>
              </div>
              <p className="section-head-text fs-5">{_data.OurMission.description}</p>
            </div>
          </div>
          <div className="col-lg-5 col-12">
            {/* <!-- IMAGE--> */}
            <div className="tw-what-wedo-section">
              <div className="row">
                <div className="col-xl-12 col-lg-6 col-md-12 p-b30">
                  <div className="tw-what-wedo-media d-flex align-items-center justify-content-center">
                    <img
                      src={_data.OurMission.image}
                      alt="#"
                      style={{ maxWidth: "50%", height: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row my-5">
          <div className="col-lg-5 col-12">
            {/* <!-- IMAGE--> */}
            <div className="tw-what-wedo-section">
              <div className="row ">
                <div className="col-xl-12 col-lg-6 col-md-12 d-flex align-items-center justify-content-center">
                  <div className="tw-what-wedo-media d-flex align-items-center justify-content-center">
                    <img
                      src={_data.OurVision.image}
                      alt="#"
                      style={{ maxWidth: "50%", height: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-12 mb-lg-0">
            {/* <!-- TITLE START--> */}
            <div className="section-head center wt-small-separator-outer">
              <div className="wt-small-separator site-text-primary">
                <div>{_data.OurVision.title}</div>
              </div>
              <p className="section-head-text fs-5">{_data.OurVision.description}</p>
            </div>
          </div>
        </div>

        <div className="row my-5">
          <div className="col-lg-7 col-12 mb-lg-0">
            {/* <!-- TITLE START--> */}
            <div className="section-head center wt-small-separator-outer">
              <div className="wt-small-separator site-text-primary">
                <div>{_data.OurValues.title}</div>
              </div>
              <p className="section-head-text fs-5">{_data.OurValues.description}</p>
            </div>
          </div>
          <div className="col-lg-5 col-12">
            {/* <!-- IMAGE--> */}
            <div className="tw-what-wedo-section">
              <div className="row ">
                <div className="col-xl-12 col-lg-6 col-md-12 d-flex align-items-center justify-content-center p-b30">
                  <div className="tw-what-wedo-media d-flex align-items-center justify-content-center">
                    <img
                      src={_data.OurValues.image}
                      alt="#"
                      style={{ maxWidth: "50%", height: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
